import React from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { useDispatch } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import * as Yup from 'yup';

import { FormikInput } from '../../components';
import { createSelectionProcessObservationRequest } from '../../requests/selectionProcessObservations';
import { sendAlert } from '../../actions/utils';

const SelectionProcessObservationForm = ({
  selectionProcessId,
  selectionProcessCandidateId,
  errors,
  touched,
  values,
  isSubmitting,
  setSubmitting,
  setModalShow,
  setRefreshObservations
}) => {
  const dispatch = useDispatch();

  const handleSubmitForm = e => {
    e.preventDefault();
    setSubmitting(true);

    createSelectionProcessObservationRequest(selectionProcessId, selectionProcessCandidateId, {
      dispatch,
      params: {
        selection_process_observation: {
          comment: values.comment
        }
      },
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Observación agregada con éxito.' }));
        setSubmitting(false);
        setModalShow(false);
        if (setRefreshObservations) setRefreshObservations(prev => !prev);
      },
      failureCallback: error => {
        const { response } = error || {};
        dispatch(sendAlert({ kind: 'error', message: response?.data?.message || 'Error al guardar la observación.' }));
        setSubmitting(false);
      }
    });
  };

  return (
    <>
      <Form id="observation-form" onSubmit={handleSubmitForm}>
        <Row>
          <Col md={12}>
            <Field name="comment">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Comentario"
                  as="textarea"
                  placeholder="Escribe aquí la observación del proceso de contratación..."
                  rows={5}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
        </Row>
      </Form>

      <Row className="mt-4">
        <Col className="d-flex justify-content-end">
          <Button
            type="submit"
            form="observation-form"
            disabled={isSubmitting || !values.comment.trim()}
            variant="primary"
          >
            GUARDAR
          </Button>
        </Col>
      </Row>
    </>
  );
};

const setInitialValues = () => ({
  comment: ''
});

const validationSchema = Yup.object().shape({
  comment: Yup.string()
    .required('Debes ingresar un comentario.')
    .max(1000, 'El comentario no puede superar los 1000 caracteres.')
});

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit: () => {},
  enableReinitialize: true
})(SelectionProcessObservationForm);
